import { UniteNode, UniteSchema } from 'types/transformation/types/nodes'

import { getColumnName, getNextColumnSuffix } from '../utils'
import DataType from 'types/transformation/enums/DataType'

export const getNewColumn = (node: UniteNode): UniteSchema => {
  const suffix = getNextColumnSuffix(node.schema)

  return {
    id: getColumnName(node.id, `aggregate_${suffix}`),
    name: '',
    reference_node: node.id,
    reference_node_index: node.index,
    left_column: null,
    right_column: null,
    type: DataType.STRING
  }
}
